import { useState } from 'react';
import { IDistributionSearchParams } from '../../../api/requests/distribution/DistributionApiGateway';
import { useDistributions } from './useDistributions';
import { useDistributionsCount } from './useDistributionsCount';

interface PropTypes {
    defaultPageSize: number;
    hideFailed?: boolean;
}

export const DistributionsSearchLocalStorageKey = 'DistributionsSearchPageNumber';
export const DistributionsPerPageKey = 'DistributionsPerPage';

export const useDistributionsSearch = (props: PropTypes) => {

    const [query, setQuery] = useState<IDistributionSearchParams>({
        pageSize: props.defaultPageSize,
        pageNumber: parseInt(window.localStorage.getItem(DistributionsSearchLocalStorageKey) ?? '1'),
        hideFailed: props.hideFailed
    });

    const distributionsResult = useDistributions(query);
    const distributionsCountResult = useDistributionsCount(query);

    const setPageNumber = (pageNumber: number) => {
        window.localStorage.setItem(DistributionsSearchLocalStorageKey, pageNumber.toString());
        setQuery({ ...query, pageNumber: pageNumber });
    };

    const setPageSize = (pageSize: number) => {
        window.localStorage.setItem(DistributionsPerPageKey, pageSize.toString());
        setQuery({ ...query, pageSize: pageSize, pageNumber: 1 });
    };

    const setHideFailed = (hideFailed: boolean) => {
        setQuery({ ...query, hideFailed: hideFailed, pageNumber: 1 });
    };

    const setHideSucceeded = (hideSucceeded: boolean) => {
        setQuery({ ...query, hideSucceeded: hideSucceeded, pageNumber: 1 });
    };

    return {
        query,
        distributionsResult,
        distributionsCountResult,
        setPageNumber,
        setPageSize,
        setHideFailed,
        setHideSucceeded
    };
};
